// Main application component with CFP authentication
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import './styles/global.css';
import { NAVIGATION_ROUTES } from './pages/routes';
import Navbar from './components/navbar/Navbar';
import AppWrapper from './layouts/AppWrapper';

import { CfpAuthProvider } from './providers/CfpAuthContext';

// Component that renders a route with conditional navbar
const RouteWithLayout: React.FC<{ route: any }> = ({ route }) => {
  if (route.path === '/' || route.path === '/error') {
    return route.component;
  }
  
  return (
    <>
      <Navbar />
      {route.component}
    </>
  );
};

// Component that handles conditional navbar rendering
const AppContent: React.FC = () => {
  return (
    <>
      <Routes>
        {NAVIGATION_ROUTES.map(route => (
          <Route
            key={`route-${route.path}`}
            path={route.path}
            element={<RouteWithLayout route={route} />}
          />
        ))}
        <Route path="*" element={<Navigate to="/" replace/>} />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  return (
    <AppWrapper>
      <CfpAuthProvider>
        <AppContent />
      </CfpAuthProvider>
    </AppWrapper>
  );
};

export default App;